import { AppExtensionService } from "@alfresco/aca-shared";
import { ProfileState, RuleContext } from "@alfresco/adf-extensions";
import { Injector } from "@angular/core";

/**
 * Determina si un contexto de plugin está habilitado.
 * @param context El contexto de aplicación.
 * @param pluginId El identificador del plugin.
 * @returns `true` si el plugin está habilitado, `false` en caso contrario.
 */
export const isPluginContextEnabled = (context: AppExtensionService, pluginId: string): boolean => { 
  const plugin = context.appConfig.config.plugins[pluginId];
  return plugin === true || plugin === 'true';
}

/**
 * Determina si un plugin está habilitado.
 * @param plugins Un objeto que contiene los estados de los plugins.
 * @param pluginId El identificador del plugin.
 * @returns `true` si el plugin está habilitado, `false` en caso contrario.
 */
export const isPluginEnabled = (plugins: { [pluginId: string]: boolean | string }, pluginId: string): boolean => { 
  const plugin = plugins?.[pluginId];
  return plugin === true || plugin === 'true';
}

/**
 * Determina si un plugin no está habilitado.
 * @param context El contexto de reglas.
 * @param injector El inyector.
 * @param serviceToken El token del servicio.
 * @returns `true` si el plugin no está habilitado, `false` en caso contrario.
 */
export function isNotPlugin(context: RuleContext, injector: Injector, serviceToken: any): boolean {
  const ruleMethodName = "isNotPlugin";
  try {
    const service = injector.get<any>(serviceToken);
    return service[ruleMethodName](context);
  } catch (e) {
    return true;
  }
}

/**
 * Determina si un usuario tiene acceso a un plugin.
 * @param profile El estado del perfil del usuario.
 * @param plugins Un objeto que contiene los estados de los plugins.
 * @param injector El inyector.
 * @param serviceToken El token del servicio.
 * @returns `true` si el usuario tiene acceso al plugin, `false` en caso contrario.
 */
export function hasPluginAccess(profile: ProfileState, plugins: { [pluginId: string]: boolean | string }, injector: Injector, serviceToken: any): boolean {
  const ruleMethodName = "hasPluginAccess";
  try {
    const service = injector.get<any>(serviceToken);
    return service[ruleMethodName](profile, plugins);
  } catch (e) {
    //console.debug("HAS PLUGIN ACCESS ERROR", e);
    return false;
  }
}